import React from 'react';
import { M131ProductDetailModule } from '~/lib/data-contract';
import { ModuleFeatureContext } from '~/templates/blocks/context/ModuleFeatureContext';
import ProductDetailDataWrapper from './product-details/product-detail-data-wrapper';

const M131ProductDetail = (props: M131ProductDetailModule) => {
    return (
        <ModuleFeatureContext.Provider value={{ reserveInStore: true }}>
            <ProductDetailDataWrapper {...props} />
        </ModuleFeatureContext.Provider>
    );
};

export default M131ProductDetail;
